import { camelizeKeys, decamelizeKeys } from 'humps';
import { post } from '@namespace/helpers';

export const readNotification = ({ notificationId }) =>
  post('/service/nc/v1/notifications/read', decamelizeKeys({ notificationId }))
    .then(camelizeKeys)
    .then(({ status, data, errorCode }) =>
      status === 'success' ? Promise.resolve(data) : Promise.reject(errorCode)
    );
